import React, { useState, useEffect, useRef } from "react";

function Tooltip({ visible, content, position, onClick }) {
    const [tooltipVisible, setTooltipVisible] = useState(visible);
    const [tooltipPosition, setTooltipPosition] = useState(position);
    const tooltipRef = useRef(null);

    useEffect(() => {
        setTooltipVisible(visible);
        setTooltipPosition(position);
    }, [visible, position]);

    const handleDocumentClick = () => {
        setTooltipVisible(false);
    };

    useEffect(() => {
        document.addEventListener("click", handleDocumentClick);
        return () => {
            document.removeEventListener("click", handleDocumentClick);
        };
    }, []);

    return (
        tooltipVisible && (
            <div
                className="fixed  z-40  inset-x-2  bottom-2  p-5  rounded-sm  bg-slate-800  text-slate-100  text-xs"
                onClick={onClick}
                ref={tooltipRef}
            >
                {content}
            </div>
        )
    );
}

export default Tooltip;
